export default [
	{
		name: 'Early Learning',
		grade: '-1'
	},
	{
		name: 'Kindergarten',
		grade: '0'
	},
	{
		name: 'First Grade',
		grade: '1'
	},
	{
		name: 'Second Grade',
		grade: '2'
	},
	{
		name: 'Third Grade',
		grade: '3'
	},
	{
		name: 'Fourth Grade',
		grade: '4'
	},
	{
		name: 'Fifth Grade',
		grade: '5'
	},
	{
		name: 'Sixth Grade',
		grade: '6'
	},
	{
		name: 'Seventh Grade',
		grade: '7'
	},
	{
		name: 'Eight Grade',
		grade: '8'
	},
    {
		name: 'Other',
		grade: '-3'
	},
	{
		name: 'Teacher Only',
		grade: '1988'
	},
]
